import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const pipelineApi = createApi({
  reducerPath: 'pipelineApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_WP_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('pipeline_token')
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  endpoints: (builder) => ({
    metaData: builder.mutation({
      query: (file) => {
        const body = new FormData()
        body.append('metadata', file)
        return { url: 'metadata', method: 'POST', body }
      },
    }),

    uploadEegFiles: builder.mutation({
      query: ({ formData }) => {
        return { url: `eegs`, method: 'POST', body: formData }
      },
    }),

    getFilters: builder.query({
      query: () => `filters`,
    }),

    preProcess: builder.mutation({
      query: ({ filter }) => ({
        url: `preprocess?filters=${filter}`,
        method: 'POST',
      }),
    }),

    getModels: builder.query({
      query: () => `models`,
    }),

    train: builder.mutation({
      query: ({ data }) => ({ url: `train_model`, method: 'POST', body: data }),
    }),

    test: builder.mutation({
      query: ({ data }) => ({ url: `test_model`, method: 'POST', body: data }),
    }),
  }),
})

export const {
  useGetFiltersQuery,
  useGetModelsQuery,
  useMetaDataMutation,
  useUploadEegFilesMutation,
  usePreProcessMutation,
  useTrainMutation,
  useTestMutation,
} = pipelineApi

export default pipelineApi
